import { Component, ComponentConfiguration } from "../base";
import { DropdownEvent } from "../event";
// import {Button} from "../common/";
import { Page } from "../../services";
import {
    computePosition as floatingUI,
    size as floatingSize,
    flip as floatingFlip,
    offset as floatingOffset,
    shift as floatingShift,
    autoUpdate,
    detectOverflow,
} from "@floating-ui/dom";

export type DropdownConfiguration = ComponentConfiguration & {
    offset?: { x: number, y: number },
};

export class Dropdown extends Component
{
    protected configuration: DropdownConfiguration;

    protected toggler: HTMLElement;

    protected togglerTextElement: HTMLElement;

    protected unfoldClass: string;

    protected state: { open: boolean };

    protected initialText: string;

    protected floatingCleanup: Function;

    constructor(...configurations: DropdownConfiguration[])
    {
        const defaults: DropdownConfiguration = {
            content_element: ".c-Dropdown__content",
            offset: {
                x: 7,
                y: 14,
            },
        };

        super(defaults, ...configurations);
    }

    public build(): this
    {
        super.build();

        this.handleDropdownUnfold = this.handleDropdownUnfold.bind(this);
        this.handleDropdownFold = this.handleDropdownFold.bind(this);
        this.handleDropdownToggle = this.handleDropdownToggle.bind(this);
        this.handleGlobalRelease = this.handleGlobalRelease.bind(this);

        this.toggler = this.querySelector(".c-Dropdown__button");
        this.unfoldClass = "c-Dropdown--unfolded";

        if(this.toggler) {
            this.togglerTextElement = this.toggler.querySelector(".c-Button__text");
            this.initialText = this.togglerTextElement.textContent;
        }

        // this.updateContentPosition();

        this.state = {
            open: false,
        };

        this.attachEvents();


        return this;
    }

    public toggle()
    {
        if (this.state.open)
            this.fold();
        else
            this.unfold();

        return this;
    }

    public updateFloating(): this
    {
        window.dispatchEvent(new Event("resize")); //force redraw

        this.floatingCleanup = autoUpdate(this.toggler, this.content,  this.updateContentPosition.bind(this), {
            layoutShift: false
        });

        return this;
    }

    public unfold()
    {
        this.addClass(this.unfoldClass);
        window.addEventListener("click", this.handleGlobalRelease);

        this.state.open = true;

        this.trigger(DropdownEvent.UNFOLD);

        this.updateFloating();

        return this;
    }

    public fold()
    {
        this.removeClass(this.unfoldClass);
        window.removeEventListener("click", this.handleGlobalRelease);

        this.state.open = false;
        this.trigger(DropdownEvent.FOLD);

        this.floatingCleanup();

        return this;
    }

    public getInitialText(): string
    {
        return this.initialText;
    }

    public setText(text: string): this
    {
        this.togglerTextElement.innerHTML = text;
        return this;
    }

    protected attachEvents()
    {
        if (this.toggler)
        {
            this.toggler.addEventListener("click", this.handleDropdownToggle);
        }

        // document.body.addEventListener("click", this.handleDropdownFold);
    }


    protected updateContentPosition(): void
    {
        if (this.toggler && this.content)
        {
            floatingUI(this.toggler, this.content, this.prepareFloatingUIOptions()).then(({ x, y }) =>
            {
                Object.assign(this.content.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                });
            });
            // this.popper = createPopper(this.toggler, this.content, this.preparePopperOptions());
        }
    }

    protected prepareFloatingUIOptions(): object
    {
        let options: object = {};
        let modifiersOptions: object = {};
        let modifiersList: any = [];

        const padding = {
            top: 0 + this.configuration.offset.y, // Header.getHeaderHeight() + this.configuration.offset.y,
            right: 0,
            bottom: this.configuration.offset.y,
            left: 0,
        };

        const defaultsOptions: object = {
            placement: "bottom-start", // at default show element at the bottom
        };

        modifiersList.push(
            floatingOffset({
                // mainAxis: -1,
                mainAxis: 0,
                // crossAxis: 0,
                crossAxis: -1,
            }),
        );

        /*
        modifiersList.push(
            floatingFlip({
                padding: padding,
                // fallbackStrategy: "initialPlacement",
            }),
        );
        */

        modifiersList.push(
            floatingShift({
                crossAxis: false,
                padding: {
                    top: 0,
                    right: this.configuration.offset.x,
                    bottom: 0,
                    left: this.configuration.offset.x,
                }
            }),
        );

        modifiersList.push(
            floatingSize({
                padding: padding,
                apply({ availableHeight, elements })
                {
                    Object.assign(elements.floating.style, {
                        // Minimum acceptable height is 100px.
                        // `flip` will then take over.
                        maxHeight: `${Math.max(100, availableHeight)}px`,
                    });
                },
            }),
        );

        /*

                modifiersList.push({
                    name: "offset",
                    options: {
                        offset: [0, -1],
                    },
                });

                modifiersList.push({
                    name: "flip",
                    options: {
                        padding: padding,
                        fallbackPlacements: ["top-start"],  // the popper will be placed on bottom if there's enough space, if not, it will try the top placement
                    },
                });

                modifiersList.push({
                    ...maxSize,
                    options: {
                        padding: padding,
                    },
                });
                modifiersList.push({
                    name: "applyMaxSize",
                    enabled: true,
                    phase: "beforeWrite",
                    requires: ["maxSize"],
                    fn({ state })
                    {
                        const { height } = state.modifiersData.maxSize;

                        state.styles.popper = {
                            ...state.styles.popper,
                            maxHeight: `${Math.max(100, height)}px`
                        };
                    },
                });*/


        if (modifiersList.length)
        {
            modifiersOptions = {
                middleware: modifiersList,
            };
        }


        options = this.mergeDeep(options, defaultsOptions, modifiersOptions);

        return options;
    }

    protected handleDropdownFold(event)
    {
        event.preventDefault();
        // event.stopPropagation();
        this.fold();
    }

    protected handleDropdownToggle(event)
    {
        event.preventDefault();
        // event.stopPropagation();
        this.toggle();
    }

    protected handleDropdownUnfold(event)
    {
        event.preventDefault();
        // event.stopPropagation();
        this.unfold();
    }

    protected handleGlobalRelease(event)
    {
        let element = event.target;

        if (!this.contains(element))
            this.fold();
    }
}